// setting the autofocus attribute in the component directly does not work.
// A small timeout is needed to ensure that the components are loaded before
// we try to set the focus
const autoFocus = (el: any) => {
  if (el) {
    setTimeout(() => {
      el.setFocus(true);
    }, 20);
  }
  return null;
};

export const useAutoFocus = () => {
  return autoFocus;
};
